module.exports = __webpack_public_path__ + "img/source_book-item4.4f9682ce.png";